/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Chat_Dictate_Microphone_UnnamedInputs */



/**
* | output |
* | --- |
* | "Microphone {index}" |
*
* @param {Chat_Dictate_Microphone_UnnamedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_dictate_microphone_unnamed = /** @type {((inputs: Chat_Dictate_Microphone_UnnamedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dictate_Microphone_UnnamedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Microfoon ${i?.index}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Micro ${i?.index}`)
	return /** @type {LocalizedString} */ (`Microphone ${i?.index}`)
});